export default {"src":"/_next/static/media/info-circle.456dbdec.svg","height":16,"width":16};